<template>
<span>

    <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
        <v-container fluid grid-list-md>
            <v-row>

                <v-col cols="10" xs="12" sm="12" md="8" lg="8" xl="8">
                    <v-row>

                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-select v-model="productsubcategory.product_category_id" :items="loadProductCategories" item-text="prod_c_nome" item-value="prod_c_id" label="Selecione uma Categoria..." :rules="rules.contentSectionRules" required outlined></v-select>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field v-model="productsubcategory.prod_sc_codigo" label="Código" outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field v-model="productsubcategory.prod_sc_nome" :rules="rules.nomeRules" label="Nome" outlined required></v-text-field>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field v-model="productsubcategory.prod_sc_ordem" label="Ordem" outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <v-text-field v-model="productsubcategory.prod_sc_link" label="Link" outlined></v-text-field>
                        </v-col>

                         <v-col cols="12" xs="12" sm="12" md="6" lg="3" xl="2">
                            <v-switch color="lime" v-model="productsubcategory.prod_sc_status" label="Status"></v-switch>
                        </v-col>

                         <v-col cols="12" xs="12" sm="12" md="6" lg="3" xl="2">
                            <v-switch color="lime" v-model="productsubcategory.prod_sc_show_menu" label="Mostrar no menu"></v-switch>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="text-right">
                            <v-btn class="btn-salvar" :disabled="!valid" color="success" @click="onSubmit">
                                <v-icon class="mdi mdi-check"></v-icon>{{btnLabel}}
                            </v-btn>
                        </v-col>

                    </v-row>
                </v-col>

                <v-col cols="2" xs="12" sm="12" md="4" lg="4" xl="4">

                    <v-layout row wrap justify-center column>

                        <v-flex d-flex justify-center v-if="previewIcone || productsubcategory.prod_sc_icone">
                            <v-card>
                                <v-img v-if="previewIcone" :src="previewIcone" aspect-ratio="1"></v-img>
                                <v-img v-if="productsubcategory.prod_sc_icone  && !previewIcone" :src="`${base_url}upload/product_subcategory/i/${productsubcategory.prod_sc_icone}`" aspect-ratio="3"></v-img>

                                <v-card-actions class="justify-center">
                                    <v-btn icon>
                                        <v-icon @click="$refs.fileIcone.click()">cloud_upload</v-icon>
                                    </v-btn>
                                    <v-btn icon>
                                        <v-icon @click.prevent="removePreviewIcone">highlight_off</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex d-flex justify-center>
                            <input type="file" ref="fileIcone" style="display:none;" id="fileIcone" @change="onFileIconeChange" accept='image/png' />
                            <v-btn v-if="!previewIcone && !productsubcategory.prod_sc_icone" color="blue-grey" class="btn-upload white--text" @click="$refs.fileIcone.click()">
                                Adicionar Icone
                                <v-icon right dark>cloud_upload</v-icon>
                            </v-btn>
                        </v-flex>

                        <v-flex justify-center d-flex v-if="previewBanner || productsubcategory.prod_sc_banner">
                            <v-card>
                                <v-img v-if="previewBanner" :src="previewBanner" aspect-ratio="1" class="img-preview"></v-img>
                                <v-img v-if="productsubcategory.prod_sc_banner && !previewBanner" :src="`${base_url}upload/product_subcategory/b/${productsubcategory.prod_sc_banner}`" aspect-ratio="1" class="img-preview"></v-img>

                                <v-card-actions class="justify-center">
                                    <v-btn icon>
                                        <v-icon @click="$refs.fileBanner.click()">cloud_upload</v-icon>
                                    </v-btn>
                                    <v-btn icon>
                                        <v-icon @click.prevent="removePreviewBanner">highlight_off</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex d-flex justify-center>
                            <input type="file" ref="fileBanner" style="display:none;" id="fileBanner" @change="onFileBannerChange" accept='image/jpg' />
                            <v-btn v-if="!previewBanner && !productsubcategory.prod_sc_banner" color="blue-grey" class="btn-upload white--text" @click="$refs.fileBanner.click()">
                                Adicionar Banner
                                <v-icon right dark>cloud_upload</v-icon>
                            </v-btn>
                        </v-flex>

                    </v-layout>

                </v-col>
            </v-row>
        </v-container>
    </v-form>

</span>
</template>

<script>
import {
    URL_BASE
} from '../../../../config/configs'

export default {
    name: "FormProductSubcategoryComponent",
    created() {
        this.$store.dispatch('loadProductCategories');
    },
    computed: {
        loadProductCategories() {
            return this.$store.state.productcategories.items.data;
        }
    },
    props: {
        productsubcategory: {
            require: false,
            type: Object | Array,
            default: () => {
                return {
                    prod_sc_id: '',
                    product_category_id: '',
                    prod_sc_codigo: '',
                    prod_sc_nome: '',
                    prod_sc_slug: '',
                    prod_sc_icone: '',
                    prod_sc_banner: '',
                    prod_sc_link: '',
                    prod_sc_ordem: '',
                    prod_sc_status: true,
                    prod_sc_show_menu: true,
                }
            }
        },
        update: {
            require: false,
            type: Boolean,
            default: false
        },
        btnLabel: {
            require: false,
            type: String,
            default: 'Salvar'
        },
        require: true,
    },
    data() {
        return {
            valid: true,
            rules: {
                nomeRules: [
                    v => !!v || 'Campo Nome é obrigatório',
                    v => (v && v.length <= 100) || 'Nome precisa ter até 100 Caracteres'
                ],
            },
            uploadIcone: null,
            fileNameIcone: 'Selecione uma foto',
            fileNameBanner: 'Selecione uma foto',
            previewIcone: null,
            previewBanner: null,
            base_url: URL_BASE
        }
    },
    methods: {
        onSubmit() {

            if (this.$refs.form.validate()) {
                const action = this.update ? 'updateProductSubcategory' : 'storeProductSubcategory';
                const msg = this.update ? 'Dados atualizados com sucesso' : 'Cadastro efetuado com sucesso';

                const formData = new FormData();

                if (this.uploadIcone !== null) {

                    if ((this.uploadIcone.type !== 'image/png')) {
                        this.$swal({
                            position: "center",
                            icon: "warning",
                            title: "O Ícone precisa ser do tipo PNG",
                            showConfirmButton: true,
                            timer: 6000
                        });
                        return
                    }

                    formData.append('prod_sc_icone', this.uploadIcone);
                }

                if (this.uploadBanner !== null)
                    formData.append('prod_sc_banner', this.uploadBanner);

                formData.append('prod_sc_id', this.productsubcategory.prod_sc_id);
                formData.append('product_category_id', this.productsubcategory.product_category_id);
                formData.append('prod_sc_codigo', this.productsubcategory.prod_sc_codigo);
                formData.append('prod_sc_nome', this.productsubcategory.prod_sc_nome);
                formData.append('prod_sc_slug', this.productsubcategory.prod_sc_slug);
                formData.append('prod_sc_icone', this.productsubcategory.prod_sc_icone);
                formData.append('prod_sc_banner', this.productsubcategory.prod_sc_banner);
                formData.append('prod_sc_link', this.productsubcategory.prod_sc_link);
                formData.append('prod_sc_ordem', this.productsubcategory.prod_sc_ordem);
                formData.append('prod_sc_status', this.productsubcategory.prod_sc_status);
                formData.append('prod_sc_show_menu', this.productsubcategory.prod_sc_show_menu);

                this.$store.dispatch(action, formData)
                    .then(() => {
                        this.$swal({
                            position: "center",
                            icon: "success",
                            title: msg,
                            showConfirmButton: true,
                            timer: 6000
                        });
                        this.$router.push({
                            name: 'product-subcategories'
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: 'Erro',
                            text: error,
                            showConfirmButton: true,
                            timer: 6000
                        });
                        this.errors = error.response.data.errors
                    })
            } else {
                this.$swal({
                    position: "center",
                    icon: "warning",
                    title: 'Alguns campos requer sua atenção',
                    text: 'Verifique os campos em vermelho',
                    showConfirmButton: true,
                    timer: 6000
                });
            }

        },
        onFileIconeChange(e) {
            let files = e.target.files || e.dataTransfer.files;

            if (!files.length)
                return;

            this.uploadIcone = files[0];

            if (this.uploadIcone) {
                if (this.uploadIcone.type !== 'image/png') {
                    this.$swal({
                        position: "center",
                        icon: "warning",
                        title: "O Ícone precisa ser do tipo PNG",
                        showConfirmButton: true,
                        timer: 6000
                    });
                    return
                }
            }

            this.fileNameIcone = this.uploadIcone.name;

            this.previewIconeImage(files[0]);
        },
        onFileBannerChange(e) {
            let files = e.target.files || e.dataTransfer.files;

            if (!files.length)
                return;

            this.uploadBanner = files[0];
            this.fileNameBanner = this.uploadBanner.name;

            this.previewBannerImage(files[0]);
        },
        previewIconeImage(file) {

            let reader = new FileReader();
            reader.onload = (e) => {
                this.previewIcone = e.target.result;
            };
            reader.readAsDataURL(file)
        },
        previewBannerImage(file) {

            let reader = new FileReader();
            reader.onload = (e) => {
                this.previewBanner = e.target.result;
            };
            reader.readAsDataURL(file)
        },
        removePreviewIcone() {
            this.previewIcone = null;
            this.uploadIcone = null;
            this.productsubcategory.prod_sc_icone = '';
        },
        removePreviewBanner() {
            this.previewBanner = null;
            this.uploadBanner = null;
            this.productsubcategory.prod_sc_banner = '';
        },
    },
    components: {

    }
};
</script>

<style scoped>
.theme--dark.v-sheet {
    background-color: #303030;
    border-color: #303030;
    color: #fff;
    box-shadow: none;
}

.btn-upload,
.btn-salvar {
    margin: 0;
}

/*Also*/
.fileinput-button input {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    opacity: 0;
    -ms-filter: 'alpha(opacity=0)';
    filter: 'alpha(opacity=0)';
    font-size: 200px;
    direction: ltr;
    cursor: pointer;
}

.img-preview {
    width: 300px;
    height: 300px;
}
</style>
